// extracted by mini-css-extract-plugin
module.exports = {"table-selector":"TableSelector_table-selector__yNvTS","button":"TableSelector_button__YFXQx","active":"TableSelector_active__mmMPs"};